export const isAlphanumeric = (str: string): boolean => !/[^A-Z0-9]/.test(str);

export const isValidClientFormat = (client: string): boolean =>
  client.length === 4 && isAlphanumeric(client);
